import { cadastro_do_reordenamento_real } from "./registra-reordenamento/cadastro-do-reordenamento-real";
import { relatorio_de_reordenamento } from "./relatorio-de-reordenamento/relatorio-de-reordenamento";
import { relatorio_de_execucao_de_reordenamento } from "./relatorio-de-execucao-de-reordenamento/relatorio-de-execucao-de-reordenamento";
import { encaminhar_alunos_reordenados } from "./encaminhar-alunos-reordenados/encaminhar-alunos-reordenados";
import { resumo_do_reordenamento } from "./resumo-do-reordenamento/resumo-do-reordenamento";
import { cadastro_de_reordenamento_a_partir_do_planejamento } from "./cadastro-de-reordenamento-a-partir-do-planejamento/cadastro-de-reordenamento-a-partir-do-planejamento";
import { arquivo_de_alunos_reordenados } from "./arquivo-de-alunos-reordenados/arquivo-de-alunos-reordenados";
import { emissao_da_confirmacao_de_matricula } from "./emissao-da-confirmacao-de-matricula/emissao-da-confirmacao-de-matricula";
import { emitir_relacao_de_alunos_transferidos } from "./emitir-relacao-de-alunos-transferidos/emitir-relacao-de-alunos-transferidos";

const reordenamento = [
  cadastro_do_reordenamento_real,
  relatorio_de_reordenamento,
  relatorio_de_execucao_de_reordenamento,
  encaminhar_alunos_reordenados,
  resumo_do_reordenamento,
  cadastro_de_reordenamento_a_partir_do_planejamento,
  arquivo_de_alunos_reordenados,
  emissao_da_confirmacao_de_matricula,
  emitir_relacao_de_alunos_transferidos,
];

export { reordenamento };
